import { NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { UrlNavigatorService } from '@shared/services';
import { GenericLinkComponent } from '@spartacus/storefront';
import { SafeUrlPipe } from '../../pipes';

@Component({
  selector: 'ui-custom-generic-link',
  templateUrl: './custom-generic-link.component.html',
  styleUrls: ['./custom-generic-link.component.scss'],
  imports: [NgIf, NgTemplateOutlet, RouterLink, RouterLinkActive, SafeUrlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CustomGenericLinkComponent extends GenericLinkComponent implements OnChanges {
  @Input() routerLinkActive: string | string[] = '';

  constructor(
    router: Router,
    private urlNavigatorService: UrlNavigatorService,
  ) {
    super(router);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.url && typeof changes.url.currentValue === 'string') {
      changes.url.currentValue = this.urlNavigatorService.removeInternalPrefix(changes.url.currentValue);
      this.url = changes.url.currentValue;
    }

    super.ngOnChanges(changes);
  }

  isExternalUrl(): boolean {
    return typeof this.url === 'string' && this.urlNavigatorService.isExternal(this.url);
  }
}
